import React from 'react';
import { useEffect, useState, useRef } from "react";
import NavButton from '../../homepage/header-banner/TopNavButton';
import styled from 'styled-components';
import Footer from '../../homepage/footer/Footer'
import Cloudconsult from '../../homepage/consult/cloudconsult';
import Banner from '../../container/Banner/Banner';
import {
    Container, Row, Col
} from 'react-bootstrap';
import { Grid } from '@mui/material';
import Titlecloudcompute from "../../container/Card/Components/Titlecloudcompute"
import Sidebar from '../../container/Sidebar/Sidebar'
import '../../container/Sidebar/sidebar.css'
import '../../Style/defaultstyle.css'
import '../../Style/defaultstyle.scss'
import CardWrap from '../components/CardWrapper';
import CommonTable from '../../container/Table/Components/CommonTable';
import CloudConsultCp from '../../homepage/consult/cloudconsult-cp';
import '../../Style/typo.css'
import BanneServerApplication from '../../container/Banner/banner-serverApplication';
import DividerComponent from '../../container/Divider/divider';
import useIsMobile from '../../container/Sidebar/useIsMobile';
import BannerPrivateCloud from '../../container/Banner/banner-privateCloud';

// Titlecloudcompute
function MessagingService() {
    const isMobile = useIsMobile();
    useEffect(() => {
        document.title = 'Messaging Service - Serverless Application - 프라이빗 클라우드';
    }, []);
    return (
        <div className='App'>
            <NavButton option={{
                // logo: logoKube,
                logo: "https://hanbiro.com/cloud/library/banner/hanbiro.svg",
                link: "https://hanbiro.com/",
                color: { backgroundColor: '#7061ff' },
                itemNavClass: "item-nav nav-pur",
                menuListProduct: "menu-list-product-item",
                menuListVora: "vora",
                menuListGroupware: "groupware",
                titleTab: "mb-3",
            }} />
            {/* {Banner("Hanbiro", "Microservice architecture")}  */}
            <BannerPrivateCloud />
            <Container className="main-body">
                <Row>
                    <Col md={12} lg={3}>
                        {!isMobile && <Sidebar />}
                    </Col>
                    <Col md={12} lg={9} className="right-content">
                        {/* {Titlecloudcompute("Messaging Service")} */}
                        <BoxContent>
                            <BoxText ><p class="typo-21-sm typo-medium typo-black">Messaging 구성도</p></BoxText>
                            <ImageWrap src="https://hanbiro.com/cloud/library2/messaging-service/messaging-service-1.svg"></ImageWrap>
                        </BoxContent>
                        <DividerComponent />
                        {/* {CardWrap("<p class='typo-21 typo-medium typo-black'>Messaging 구성도</p>", "", "", "https://hanbiro.com/cloud/library2/messaging-service/messaging-service-1.svg")} */}
                        <BoxContent>
                            <BoxTitle className='sub-title'><p class="typo-21 typo-medium typo-black">Message Entity 의 차이점</p></BoxTitle>

                            <CommonTable
                                header={{
                                    row_1: [
                                        { title: "&nbsp;", },
                                        { title: "<p class='typo-14 typo-medium typo-white'>Topic</p>", },
                                        { title: "<p class='typo-14 typo-medium typo-white'>Queue</p>", },
                                        { title: "<p class='typo-14 typo-medium typo-white'>Channel</p>", },
                                    ],
                                }}
                                content={{
                                    row_1: [
                                        { title: "<p class='typo-14 typo-medium typo-black'>Delivery</p>", },
                                        {
                                            title: `<div style='text-align:center'>At Least Once (Exactly Once) <br>
                                            <p class='typo-14 purple-primary'>(Committing Offset 방식)</p> 
                                            <img src='https://hanbiro.com/cloud/images/cloud/question.svg' width='20px'></img></div>`},
                                        {
                                            title: `<div style='text-align:center'>At Least Once (Exactly Once) <br> 
                                            <p class='typo-14 purple-primary'>(Ack Reply 방식)</span> 
                                            <img src='https://hanbiro.com/cloud/images/cloud/question.svg' width='20px'></img></div>`},
                                        { title: "<div style='text-align:center'>At Most Once</div>", }
                                    ],
                                    row_2: [
                                        { title: "<p class='typo-14 typo-medium typo-black'>Storage</p>", },
                                        { title: "<p class='typo-14' style='text-align:center'>Disk</p>", },
                                        { title: "<p class='typo-14' style='text-align:center'>Disk</p>", },
                                        { title: "<p class='typo-14' style='text-align:center'>In Memory</p>", },
                                    ],
                                    row_3: [
                                        { title: "<p class='typo-14 typo-medium typo-black'>Ordering</p>", },
                                        { title: "<p class='typo-14' style='text-align:center'>순서보장</p>", },
                                        { title: "<p class='typo-14' style='text-align:center'>순서보장안함</p>", },
                                        { title: "<p class='typo-14' style='text-align:center'>X</p>", },
                                    ],
                                    row_4: [
                                        { title: "<p class='typo-14 typo-medium typo-black'>Consumer</p>", },
                                        { title: "<p class='typo-14' style='text-align:center'>Pub / Sub</p>", },
                                        { title: "<p class='typo-14' style='text-align:center'>1:1</p>", },
                                        { title: "<p class='typo-14' style='text-align:center'>Fan Out (Broadcast)</p>", },
                                    ],
                                }} />
                            <BoxText><p class="typo-14 typo-medium purple-primary">• Committing Offset 방식 </p></BoxText>
                            <BoxSubText><p class="typo-14 purple-primary">Consumer 가 Poll을 호출할때 각 파티션에 자신이 가져간 메세지 위치(Offset)을 업데이트 함 (Commit)</p></BoxSubText>
                            <BoxText><p class="typo-14 typo-medium purple-primary">• Ack Reply 방식</p></BoxText>
                            <BoxSubText><p class="typo-14 purple-primary">Consumer 나 Endpoint 가 메세지를 받은후 Ack 신호를 주고 해당 메세지는 삭제</p></BoxSubText>
                        </BoxContent>
                        <DividerComponent />
                        {CardWrap(
                            "Pull 과 Push 의 차이점",

                            {
                                row_1: [
                                    { Cols50: "True", title: "<p class='typo-14 typo-medium typo-white'>Pull</p>" },
                                    { title: "<p class='typo-14 typo-medium typo-white'>Push</p>" },
                                ]
                            },

                            {
                                row_1: [
                                    {
                                        bold: "False", title: `<p class='typo-14'>Streaming Pull 지원. </p>
                                                        <p class='typo-14'>Consumer 가 API 를 호출해서 Message 를 가져감.</p>`},
                                    { title: "<p class='typo-14'>Worker가 Message를 받아 GRPC Unary나 URL Get/Post를 보냄.</p>" }
                                ]
                            })}
                        <DividerComponent />
                        <BoxContent>
                            <BoxTitle className='sub-title'><p class="typo-21 typo-medium typo-black">Subscription 의 특성</p></BoxTitle>
                            <BoxTextNone className='breakword'>
                                <p class="typo-14"><b>Message Entity (Topic / Queue / Channel)</b> 은 복수의 <b>Subscription</b>(구독)을 가질 수 있으나, <br />
                                    한개의 주어진 <b>Subscription</b> 은 하나의 <b>Message Entity</b> 만 가질 수 있다.</p></BoxTextNone>
                            {/* {Imagecloudcompute("https://hanbiro.com/cloud/library2/messaging-service/messaging-service-2.svg")} */}
                            <ImageWrap src="https://hanbiro.com/cloud/library2/messaging-service/messaging-service-2.svg"></ImageWrap>
                        </BoxContent>
                        {/*
                        {CardWrap("• Vora Desk Messaging Service 요약","","","https://hanbiro.com/cloud/library2/messaging-service/messaging-service-3.svg")}
                        */}

                        {/* <CloudConsultCp /> */}
                    </Col>
                </Row>
            </Container>


            {/* <Cloudconsult /> */}
            <Footer option={{
                textColor: "text-color external-link text-pur-color",
                textlinkColor: "text-color text-pur-color"
            }} />
        </div>
    );
};

const BoxSubText = styled.div`
  margin-left: 1.5%;
  color: #48A7FC;
`

const Box = styled.div`
  @media only screen and (max-width: 767px){
    font-size: 80%;
  }
`

const BoxContent = styled.div`
    ${'' /* box-shadow: 0 0.375rem 1.5rem 0 rgb(140 152 164 / 13%);
    border: 1px solid #E7EAF3;
    border-radius: 4px;
    margin-top: 20px;
    margin-bottom: 20px; */}
    text-align: left;
`

const BoxText = styled.div`
    margin: 5px;
    line-height: 2em;
    color: #48A7FC;
    font-weight: bold;
`

const BoxTextNone = styled.div`
    margin: 5px;
    line-height: 2em;
`

const BoxTitle = styled.div`
  text-align: left;
  font-weight: bold;
  font-size: 20px;
  margin-bottom: 20px;
`

const ImageWrap = styled.img`
  width: 100%;
  object-fit: fill;
`

export default MessagingService;
